import React from 'react';
import {Grid, Row, Col} from 'react-bootstrap'
import {renderTestFields, statuses} from '../../constants'
import options from '../../../resources/images/options.png'

const TestView = ({test, showOptions, optionsClick, overBudget, thisTestUnderBudget, showGroups, groups, compact}) => {

    const fields = renderTestFields(test, false, compact, overBudget, thisTestUnderBudget, true)
    const extraClassNames = (test.status === statuses.SCHEDULED && !test.antarctic && !test.naturalDisaster && !test.approved && overBudget) ? `test-row-breach` :
        (test.status === statuses.SCHEDULED && !test.antarctic && !test.naturalDisaster && !test.approved && test.unplanned) ? `test-row-unplanned` : ``

    //console.log('TestView', 'thisTestUnderBudget', thisTestUnderBudget, test, extraClassNames)
    return (
        <Row className={`test-row ${extraClassNames}`}>
            <Col className="test-cell test-cell-left" sm={1} xs={2}>
                {fields.ref}
            </Col>
            <Col className="test-cell" sm={2} xs={4}>
                {fields.startedAt}
            </Col>
            <Col className="test-cell" sm={showGroups ? 1 : 2} xs={showGroups ? 2 : 4}>
                {fields.schedulerName}
            </Col>
            {showGroups && <Col className="test-cell" sm={1} xs={2}>
                {(groups[test.group] || {}).name || ''}
            </Col>}
            <Col className="test-cell" sm={1} xs={2}>
                {fields.aircraft}
            </Col>
            <Col className="test-cell test-cell-xs-left" sm={1} xs={2}>
                {fields.aircraftRegistration}
            </Col>
            <Col className="test-cell test-cell-xs-left" sm={1} xs={2}>
                {fields.power}
            </Col>
            <Col className="test-cell" sm={2} xs={4}>
                {fields.departure}
            </Col>
            <Col className="test-cell" sm={2} xs={4}>
                <Grid fluid>
                    <Row >
                        <Col xs={10} style={{overflow: 'hidden', paddingRight: '4px'}} onClick={(e) => { if (compact && showOptions) {optionsClick(test,e)} /*for smaller devices, make this cell clickable also*/ }}>
                            {`${fields.status}`}
                        </Col>
                        {showOptions && <Col xs={2} style={{textAlign: 'right', paddingRight: '6px'}} onClick={(e) => optionsClick(test,e)}>
                            <img src={options} alt="" style={{height: "10px", width: "2px"}} />
                        </Col>}
                    </Row>
                </Grid>
            </Col>
        </Row>
    )
}

export default TestView







// WEBPACK FOOTER //
// ./src/components/tests/TestView.js